import {Navigate, Outlet} from "react-router-dom";
import {useAuth} from "@/hooks/useAuth";
import {AuthGateLoader} from "./AuthGateLoader";

export const RequireAuth = () => {
  const {isAuthenticated, isLoading} = useAuth();

  if (isLoading) return <AuthGateLoader />;

  return isAuthenticated ? <Outlet /> : <Navigate to="/auth/sign-in" replace />;
};
